<auth-header></auth-header>
<form 
    *ngIf="!submitted"
    #form="ngForm"
    (ngSubmit)="onSubmit(form)"
    novalidate>
    <h1>New Password</h1>
    <p class="password-requirements">Your password must include from 6 to 20 letters and digits</p>
    <ui-input>
        <input 
            uiInput
            type="password"
            name="password"
            #password="ngModel"
            [(ngModel)]="model.password"
            (ngModelChange)="onHideError()"
            placeholder="New Password"
            validateEqual="confirmPassword"
            reverse="true"                                                                 
            pattern="[\w]+"
            minlength="6"
            maxlength="20"
            required
        />
        <ui-input-error [input]="password" name="required">Password is required</ui-input-error>
        <ui-input-error [input]="password" name="password">Please enter a valid password</ui-input-error>
    </ui-input>
    <ui-input>
        <input 
            uiInput
            type="password"
            name="confirmPassword"
            #confirmPassword="ngModel"
            [(ngModel)]="model.confirmPassword"
            (ngModelChange)="onHideError()"
            placeholder="Confirm Password"
            validateEqual="password"
        />
        <ui-input-error [input]="confirmPassword" name="validateEqual">The password fields do not match</ui-input-error>
    </ui-input>
    <div class="ui-input-error" *ngIf="error" [ngSwitch]="error" [class.visible]="error">
        <span *ngSwitchCase="'tokenExpired'">The Link is Invalid or Expired</span>
        <span *ngSwitchCase="'invalidModel'">Invalid Password</span>
    </div>
    <button type="submit" class="default" (click)="validate(form)">Save</button>
    <ui-loading *ngIf="processing"></ui-loading>
</form>
<div *ngIf="submitted" class="submitted-dialog">
    <h1>Your password has been changed</h1>
    <button class="default" (click)="onOk()">OK</button>
</div>
<auth-footer></auth-footer>